export enum FontSize {
    Normal = 'normal',
    Large = 'large',
    ExtraLarge = 'extra-large',
    Huge = 'huge',
}
